export type FsLivesRulesBase = {
  livesLost: number | undefined;
  numDrivers: number | undefined;
};

export type FsLivesRules =
  | FsDriverLivesRules
  | FsRemainingLivesRules
  | FsTrackLivesRules;

export type FsDriverLivesRules = FsLivesRulesBase & {
  tillLeft: number | undefined;
};

export type FsRemainingLivesRules = FsLivesRulesBase & {
  tillRemaining: number | undefined;
};

export type FsTrackLivesRules = FsLivesRulesBase & {
  startTrack: number | undefined;
  endTrack: number | undefined;
};

export const isFsDriverLivesRules = (
  rules: FsLivesRules
): rules is FsDriverLivesRules => {
  return (rules as FsDriverLivesRules).tillLeft !== undefined;
};

export const isFsRemainingLivesRules = (
  rules: FsLivesRules
): rules is FsRemainingLivesRules => {
  return (rules as FsRemainingLivesRules).tillRemaining !== undefined;
};
